export default {
  navigationRow1: 'Design Navigator是一款智能的轻量级CAD应用程序，轻量级用户可以用它查询并反馈产品设计情况，反馈的结果可以回馈给CAD工具进行优化模型设计，降低了用户对昂贵复杂的CAD软件的依赖性。 该软件无需任何安装，远程用户能够快速轻松地访问与其角色及任务相关的功能。',
  navigationRow2: '内置RPA工具和规则学习引擎，降低成本，提高质量，基于历史设计或类似设计提出针对制造的设计建议。',
  navigationRow3: '与企业业务流程和运营无缝集成，改善部门间协作，包括研发、制造和设计标准。',
  navigationRow4: '使得工程师专注设计和制造优化，提升开发速度，维稳质量，降低软件投入成本。'
}
